export default "__VITE_ASSET__D0ysfGUC__"